import { useContext } from "react";
import { TranslationsContext } from "@/core/contexts/TranslationsContext";

/**
 * Analogue of translation func in i18n module, it
 * returns a requested query itself if the alias
 * is missing in the general tranlations object
 *
 * @param {string} query - query like "airports.title"
 * @returns {string} - "Welome" or "airports.title"
 */

const useTranslations = (query?: string): string => {
  const translationsContext = useContext(TranslationsContext);

  if (translationsContext && translationsContext.translations && query) {
    const isQueryFound =
      typeof translationsContext.translations[query] !== "undefined";
    return isQueryFound ? translationsContext.translations[query] : query;
  } else {
    return "";
  }
};

export { useTranslations };
